export interface LogoInterface {
    normalUrl:string;
    medianoUrl:string;
}

export class Logo {
    constructor(
        public normalUrl:string,
        public medianoUrl:string
    ) {
    }
}

export class LogoMaker {
    static createInterface(event:LogoInterface):LogoInterface {
        return { normalUrl: event.normalUrl, medianoUrl: event.medianoUrl }
    }

    static create(event: Logo) {
        return new Logo( event.normalUrl, event.medianoUrl );
    }
}